import { type KeyboardEvent } from 'react';

// Cmd+Enter (Ctrl+Enter off macOS) submits a form, even from a multi-line
// field where Enter adds a line.
export const isSubmitShortcut = (event: KeyboardEvent) =>
  event.key === 'Enter' && (event.metaKey || event.ctrlKey);
